<template>
    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.58381 12.3521C5.74566 12.5174 5.94798 12.6 6.17052 12.6C6.37283 12.6 6.59538 12.5174 6.75723 12.3521C7.08092 12.0216 7.08092 11.4846 6.75723 11.1541L2.00289 6.3L6.75723 1.4459C7.08092 1.11541 7.08092 0.578361 6.75723 0.247869C6.43353 -0.082623 5.90751 -0.082623 5.58381 0.247869L0.242774 5.70098C0.0809242 5.86623 0 6.07279 0 6.3C0 6.52721 0.0809242 6.73377 0.242774 6.89902L5.58381 12.3521Z"
            fill="white" />
    </svg>
</template>

<script>
export default {
    name: "IconSliderArrow"
}
</script>

<style scoped></style>